import {
  useCallback,
  useMemo,
  useState,
} from 'react';
import type {
  ReactNode,
} from 'react';

import type {
  HeaderLeftBlockContextValue,
} from './HeaderLeftBlockContext';

export const useHeaderLeftBlock = () => {
  const [blocks, setBlocks] = useState<ReactNode[]>([]);

  const setBlock = useCallback((block: ReactNode) => {
    setBlocks((prevBlocks) => [
      ...prevBlocks,
      block,
    ]);

    return () => {
      setBlocks(
        (prevBlocks) => prevBlocks.filter((settedBlock) => settedBlock !== block),
      );
    };
  }, []);

  const renderedBlock = useMemo<ReactNode | null>(() => {
    if (blocks.length === 0) {
      return null;
    }

    return blocks[blocks.length - 1];
  }, [blocks]);

  const contextValue = useMemo<HeaderLeftBlockContextValue>(() => ({
    setBlock,
  }), [setBlock]);

  return {
    renderedBlock,
    contextValue,
  };
};
